import React, { useState, useContext, useEffect } from 'react';
import 'antd/dist/antd.css';
import { UploadOutlined } from '@ant-design/icons';
import { Drawer, Button, message, Upload, Tooltip } from 'antd';
import person_img from 'images/drawer/person_img.svg';

import { _l } from 'lib/utils.js';

import { AppContext } from 'context/AppContext';
import { cloneDeep } from 'lodash';

import { changeUserData } from 'services/user.js';

const EditUserAccountDetails = (props) => {
    let appContext = useContext(AppContext);

    let userImg;
    if (appContext.userImg !== null) {
        userImg = appContext.userImg;
    } else {
        userImg = person_img;
    }

    const [firstName, setFirstName] = useState(appContext.defaults.first_name);
    const [lastName, setLastName] = useState(appContext.defaults.last_name);
    const [msgTooBigFile, setMsgTooBigFile] = useState(false);
    const [msgNotPicture, setMsgNotPicture] = useState(false);

    // const hadleToogleMsg = () => {
    //     setMsgTooBigFile(!msgTooBigFile);
    // };

    const uploadData = {
        accept: 'image/png, image/gif, image/jpeg',
        name: 'user_img',
        action:
            process.env.REACT_APP_API_URL +
            // '/api/v1/users/change-profile-image/',
            `/api/v1/users/profile/${appContext.defaults.user_id}/`,
        multiple: false,
        method: 'PATCH',
        showUploadList: false,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`
        },

        beforeUpload(file) {
            console.log(`file from beforeUpload`, file);
            console.log(`file.size from beforeUpload`, file.size);

            // let isPicture =
            //     file.type === 'image/png' || file.type === 'iamge/jpeg';

            if (file.size > 1000000) {
                // message.error(
                //     `File is too big. The maximum size of the photo is 1MB`
                // );
                setMsgTooBigFile(true);
                return false;
            }
            // } else if (!isPicture) {
            //     setMsgNotPicture(true);
            //     return false;
            // }
        },

        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (info.file.status === 'done') {
                // message.success(`${info.file.name} file uploaded successfully`);
                // console.log(`info`, info);
                setMsgTooBigFile(false);
                setMsgNotPicture(false);
                props.setRerenderUserDetailsDrawer(
                    !props.rerenderUserDetailsDrawer
                );
                appContext.setUserImg(info.file.response.user_img);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        }
    };

    const handleInputChange = (target, value) => {
        if (target == 'first_name') {
            setFirstName(value);
        } else if (target == 'last_name') {
            setLastName(value);
        }
    };

    const handleSendUserData = () => {
        let data = {
            first_name: firstName,
            last_name: lastName
        };

        changeUserData(appContext.defaults.user_id, data).then((res) => {
            if (res.status == 200) {
                appContext.syncTokenFromSessionStore();
                props.onClose();
            }
        });
    };

    return (
        <>
            <Drawer
                // title="Basic Drawer"
                placement="right"
                onClose={props.onClose}
                visible={props.visible}
                closable={false}
                width={357}
            >
                <div className="edit-details-account-container">
                    <div className="change-password-container">
                        <div className="header">
                            <div className="title">Edit Account</div>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            style={{
                                marginTop: '15px',
                                marginBottom: '15px',
                                height: '120px',
                                width: '120px',
                                borderRadius: '50%',
                                backgroundImage: `url(${userImg})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}
                        />

                        <Upload {...uploadData}>
                            {/* <Button icon={<UploadOutlined />}> */}
                            <Tooltip
                                className="tes1"
                                id="tooltip-avatar-upload"
                                visible={
                                    msgTooBigFile
                                        ? setTimeout(() => {
                                              setMsgTooBigFile(false);
                                          }, 7000)
                                        : false
                                }
                                placement="left"
                                color="#fff"
                                // getPopupContainer={() => {}}
                                title={() => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    padding: '14px 12px',
                                                    color: '#3D3F4D',
                                                    fontFamily: 'Roboto Medium',
                                                    fontSize: '14px',
                                                    lineHeight: '22px'
                                                }}
                                            >
                                                The file is too big. Maximum
                                                file size is 1MB. <br></br>
                                                Please upload a smaller file.
                                            </div>
                                            <div className="square"></div>
                                        </>
                                    );
                                }}
                            >
                                <Tooltip
                                    className="tes1"
                                    id="tooltip-avatar-upload"
                                    visible={
                                        msgNotPicture
                                            ? setTimeout(() => {
                                                  setMsgNotPicture(false);
                                              }, 7000)
                                            : false
                                    }
                                    placement="left"
                                    color="#fff"
                                    // getPopupContainer={() => {}}
                                    title={() => {
                                        return (
                                            <>
                                                <div
                                                    style={{
                                                        padding: '14px 12px',
                                                        color: '#3D3F4D',
                                                        fontFamily:
                                                            'Roboto Medium',
                                                        fontSize: '14px',
                                                        lineHeight: '22px'
                                                    }}
                                                >
                                                    This file type is not
                                                    supported.<br></br>Please
                                                    upload a JPG, JPEG or PNG
                                                    file.
                                                </div>
                                                <div className="square"></div>
                                            </>
                                        );
                                    }}
                                >
                                    <Button
                                        className="blue-button"
                                        type="primary"
                                    >
                                        Click to Upload
                                    </Button>
                                </Tooltip>
                            </Tooltip>
                        </Upload>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '25px'
                        }}
                    >
                        <div className="edit-card">
                            <div className="name">First Name</div>
                            <div className="value">
                                <input
                                    onChange={(e) =>
                                        handleInputChange(
                                            'first_name',
                                            e.target.value
                                        )
                                    }
                                    // value={appContext.defaults.first_name}
                                    value={firstName}
                                />
                            </div>
                        </div>
                        <div className="edit-card">
                            <div className="name">Last Name</div>
                            <div className="value">
                                <input
                                    onChange={(e) =>
                                        handleInputChange(
                                            'last_name',
                                            e.target.value
                                        )
                                    }
                                    // value={appContext.defaults.last_name}
                                    value={lastName}
                                />
                            </div>
                        </div>
                        <div className="edit-card">
                            <div className="name">Username</div>
                            <div className="value">
                                <input
                                    style={{
                                        opacity: '0.5',
                                        cursor: 'not-allowed'
                                    }}
                                    readOnly
                                    value={appContext.defaults.username}
                                />
                            </div>
                        </div>
                        <div className="edit-card">
                            <div className="name">Email</div>
                            <div className="value">
                                <input
                                    readOnly
                                    style={{
                                        opacity: '0.5',
                                        cursor: 'not-allowed'
                                    }}
                                    value={appContext.defaults.email}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="button-container">
                        <div className="btn-save">
                            {JSON.stringify(firstName) ==
                                JSON.stringify(
                                    appContext.defaults.first_name
                                ) &&
                            JSON.stringify(lastName) ==
                                JSON.stringify(
                                    appContext.defaults.last_name
                                ) ? (
                                <Tooltip title="There's nothing to change">
                                    <Button disabled>Save</Button>
                                </Tooltip>
                            ) : (
                                <Button
                                    onClick={() => {
                                        handleSendUserData();
                                    }}
                                >
                                    Save
                                </Button>
                            )}
                        </div>
                        <div className="btn-cancel">
                            <Button
                                onClick={() => {
                                    props.onClose();
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    );
};

export default EditUserAccountDetails;
